export default {
  streaming: 'streaming',
  replication: 'replication',
  cdc: 'cdc',
  elt: 'elt',
  spark: 'spark',
  in_memory: 'in_memory',
  custom: 'custom',
  genai_rag: 'genai_rag',
  api_server: 'api_server',
} as const;

export const FLOW_CATEGORY = {
  flow_types: 'flow_types',
  processing_engine: 'processing_engine',
  flow_wizard: 'flow_wizard',
  coming_soon: 'coming_soon',
};

export const FLOW_CHIPS = {
  recommended: 'recommended',
  early_access: 'early_access',
};
